import { request } from './index';

export type ExamOverviewType = {
  id: number;
  name: string;
  status: boolean;
};

export type ExamType = ExamOverviewType & {
  questionCount: number;
  lessons?: number[];
  lessonCount: number;
  studentFinishedCount: number;
  duration: number;
  analysis: boolean;
  penalty: boolean;
  initiated: string;
  isInitiated: boolean;
  expired: string;
  isExpired: boolean;
  introduction?: string;
  description?: string;
  voice?: string;
};

export type ExamChartType = {
  id: number;
  name: string;
};

export async function fetchAvailableExams(): Promise<ExamType[]> {
  return await request(true, { url: '/exams/exams' });
}

export async function fetchExam({
  queryKey: [_, examId]
}: {
  queryKey: [string, number];
}): Promise<ExamType> {
  return await request(true, { url: `/exams/exams/${examId}` });
}
